export function getActivityTemplateLabel(template) {
  return template?.activityInfo?.title?.trim()
    || template?.name?.trim()
    || '未命名單元';
}
